export default (() => {

    const global = {
        elements: {},
        pageData: {}
    };

    function initialise(options, isRecurringPayment) {
        _cacheElements();
        _cachePageData(isRecurringPayment);
        _initialiseComponents(options);
    }

    function _cacheElements() {
        global.elements = {
            progressBar: document.querySelector('[data-progress-bar]'),
            buttonSubmit: document.querySelector('[data-button-submit]'),
            buttonCancel: document.querySelector('[data-button-cancel]')
        };
        global.fields = {
            title: document.querySelector('[data-field-title]'),
            gender: document.querySelector('[data-field-gender]'),
            dob: document.querySelector('[data-field-dob]'),
            addressLine1: document.querySelector('[data-field-address-line-1]'),
            addressLine2: document.querySelector('[data-field-address-line-2]'),
            addressLine3: document.querySelector('[data-field-address-line-3]'),
            cityTown: document.querySelector('[data-field-address-city-town]'),
            postcode: document.querySelector('[data-field-address-postcode]'),
            country: document.querySelector('[data-field-address-country]'),
            moneySource: document.querySelector('[data-field-money-source]'),
            employmentStatus: document.querySelector('[data-field-employment-status]'),
            profession: document.querySelector('[data-field-profession]'),
        };
        global.groups = {
            profession: document.querySelector('[data-group-profession]'),
            employmentStatus: document.querySelector('[data-group-employment-status]')
        };
    }

    function _cachePageData(isRecurringPayment) {
        global.pageData = {
            portfolioId: document.querySelector('[data-portfolio-id]').value,
            isRecurringPayment: isRecurringPayment
        };
    }

    function _initialiseComponents(options) {
        _bindProgressBar();
        _removeFirstItemFromOptions(options.title);
        _removeFirstItemFromOptions(options.moneySource);
        _bindItemsToField(global.fields.title, options.title);
        _bindItemsToField(global.fields.gender, options.gender);
        _bindItemsToField(global.fields.country, options.country);
        _bindItemsToField(global.fields.moneySource, options.moneySource);
        _bindItemsToField(global.fields.employmentStatus, options.employmentStatus);
        _bindEmploymentStatus();
        _bindProfessionTextbox();
    }

    function _bindProgressBar() {

        const recurringUrlFlag = global.pageData.isRecurringPayment ? 'Recurring' : '';

        global.elements.progressBar.steps = [
            {
                label: '1',
                titleprop: 'Options',
                state: 'complete',
                onclickprop: () => {
                    window.location = `${window.location.origin}${global.elements.progressBar.getAttribute('data-options-url') + recurringUrlFlag}/${global.pageData.portfolioId}`;
                },
            },
            {
                label: '2',
                titleprop: 'Your details',
                state: 'selected',
            },
            {
                label: '3',
                titleprop: 'Bank details',
                disabledprop: true,
            },
            {
                label: '4',
                titleprop: 'Confirmation',
                disabledprop: true,
            },
        ];
    }

    function _removeFirstItemFromOptions(options) {
        options.labels.shift();
        options.values.shift();
    }

    function _bindItemsToField(node, options) {
        const isArray = Array.isArray(options);
        const mainArray = isArray ? options : options.labels;

        node.items = mainArray.map((option, index) => {
            return {
                label: isArray ? option : options.labels[index],
                value: isArray ? option : options.values[index],
            };
        });
    }

    function _bindEmploymentStatus() {
        global.fields.employmentStatus.addEventListener('valuechange', _bindProfessionTextbox);
    }

    function _bindProfessionTextbox() {
        const isEmployed = global.fields.employmentStatus.value === '0' || global.fields.employmentStatus.value === '1'; // Employed or Self Employed
        const professionClassAction = isEmployed ? 'remove' : 'add';

        global.fields.profession.required = isEmployed;

        if (!isEmployed) {
            global.fields.profession.value = '';
        }

        global.groups.profession.classList[professionClassAction]('u-display__none');
        global.groups.employmentStatus.classList[professionClassAction]('u-margin__bottom-mobile--0');
    }

    return { initialise };
})();